module.exports = __webpack_public_path__ + "static/media/white_wine_feature.97ab65ab.jpg";